import { useMediaQuery } from "./useMediaQuery.js";
import { MOBILE_QUERY, TOUCH_QUERY } from "../utils/viewport.js";

/**
 * True at phone width (utils/viewport MOBILE_QUERY), live across resizes and
 * orientation changes. Components that used to keep their own
 * `window.innerWidth <= 767` state read this instead, so every JS branch
 * flips at the same width as the CSS.
 */
export function useIsMobile() {
  return useMediaQuery(MOBILE_QUERY);
}

/** True on a touch-first device (no hover, coarse pointer). */
export function useIsTouch() {
  return useMediaQuery(TOUCH_QUERY);
}
